export default "__VITE_ASSET__cUiGg78F__"